import src from "IMAGE";
export default { src, width: 1920, height: 1135, blurWidth: 8, blurHeight: 5, blurDataURL: "data:image/webp;base64,UklGRnwAAABXRUJQVlA4THAAAAAvBwABEM1VICICHggwDQAAAICFgjABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGXQDwIARHggEgAAAAAA598AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ERwMC6sg2eyihF8LaMB"};
